// Map form fields between what the editor expects and what rails expects.
// The collaborative editor (Ydoc) saves fields with snake_case keys to the DB,
// but the React editor expects camelCase. This mapping bridges the gap.
//
// Uses generic camelCase <-> snake_case conversion so new properties are
// handled automatically. Only special case: `defaultValue` <-> `default`
// (not `default_value`).

const SPECIAL_CAMEL_TO_SNAKE = {
  defaultValue: "default",
};

const SPECIAL_SNAKE_TO_CAMEL = Object.fromEntries(
  Object.entries(SPECIAL_CAMEL_TO_SNAKE).map(([c, s]) => [s, c])
);

function camelToSnake(str) {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

function snakeToCamel(str) {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

function convertKeys(obj, converter, specialMap) {
  const result = {};
  for (const [key, value] of Object.entries(obj)) {
    const newKey = specialMap[key] || converter(key);
    result[newKey] = value;
  }
  return result;
}

export function fieldsToRails(fields) {
  return fields.map((f) => {
    if (f.fields && f.fields.map) {
      f = { ...f, fields: fieldsToRails(f.fields) };
    }
    return convertKeys(f, camelToSnake, SPECIAL_CAMEL_TO_SNAKE);
  });
}

export function fieldsFromRails(fields) {
  return fields.map((f) => {
    let converted = convertKeys(f, snakeToCamel, SPECIAL_SNAKE_TO_CAMEL);
    if (converted.fields && converted.fields.map) {
      converted = { ...converted, fields: fieldsFromRails(converted.fields) };
    }
    return converted;
  });
}
